export default "__VITE_ASSET__BgLSV56A__"